module.exports = __webpack_public_path__ + "static/media/fire-safes.f99d2cfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/hero/fire-safes.jpg
// module id = 1245
// module chunks = 0